import React, { useEffect, useState } from "react";
import Adminchats from "./Adminchats"
const Adminpermission=()=>{
    return(
        <Adminchats permission={true}/>
    )
}
export default Adminpermission;